export default __webpack_public_path__ + "48cbf94c622d9622f0f0733ff9d40bc9.jpg";